import '@web.awesome.me/webawesome-pro/dist/styles/themes/default.css'
import '@web.awesome.me/webawesome-pro/dist/styles/utilities.css'
import './theme-light.css'

import '@web.awesome.me/webawesome-pro/dist/components/callout/callout.js'
import '@web.awesome.me/webawesome-pro/dist/components/toast/toast.js'
import '@web.awesome.me/webawesome-pro/dist/components/dropdown/dropdown.js'
import '@web.awesome.me/webawesome-pro/dist/components/badge/badge.js'
import '@web.awesome.me/webawesome-pro/dist/components/button/button.js'
import '@web.awesome.me/webawesome-pro/dist/components/card/card.js'
import '@web.awesome.me/webawesome-pro/dist/components/carousel/carousel.js'
import '@web.awesome.me/webawesome-pro/dist/components/carousel-item/carousel-item.js'
import '@web.awesome.me/webawesome-pro/dist/components/icon/icon.js'
import '@web.awesome.me/webawesome-pro/dist/components/input/input.js'
import '@web.awesome.me/webawesome-pro/dist/components/textarea/textarea.js'
import '@web.awesome.me/webawesome-pro/dist/components/divider/divider.js'
import '@web.awesome.me/webawesome-pro/dist/components/checkbox/checkbox.js'
import '@web.awesome.me/webawesome-pro/dist/components/checkbox-group/checkbox-group.js'
import '@web.awesome.me/webawesome-pro/dist/components/select/select.js'
import '@web.awesome.me/webawesome-pro/dist/components/option/option.js'
import '@web.awesome.me/webawesome-pro/dist/components/radio-group/radio-group.js'
import '@web.awesome.me/webawesome-pro/dist/components/file-input/file-input.js'
import '@web.awesome.me/webawesome-pro/dist/components/date-input/date-input.js'
import '@web.awesome.me/webawesome-pro/dist/components/time-input/time-input.js'
import '@web.awesome.me/webawesome-pro/dist/components/tooltip/tooltip.js'
import WaColorPicker from '@web.awesome.me/webawesome-pro/dist/components/color-picker/color-picker.js'
import '@web.awesome.me/webawesome-pro/dist/components/dialog/dialog.js'
import '@web.awesome.me/webawesome-pro/dist/components/progress-bar/progress-bar.js'
import '@web.awesome.me/webawesome-pro/dist/components/details/details.js'
import '@web.awesome.me/webawesome-pro/dist/components/relative-time/relative-time.js'

import { setKitCode } from '@web.awesome.me/webawesome-pro/dist/webawesome.js'
import { preventTurboFouce } from '@web.awesome.me/webawesome-pro/dist/webawesome.js'

setKitCode('d7d02138b5') // Font Awesome kit
preventTurboFouce()

// wa-color-picker syncs its initial `value` into colour state in the constructor,
// before the `opacity` attribute has applied. With opacity still off it emits a
// 6-digit hex, drops the alpha, and stores that alpha-less string as the value —
// which never re-syncs once opacity turns on. Re-apply the original `value` once
// the element has rendered (opacity now in effect) so an opacity picker keeps the
// alpha in both its state and its submitted value. Reported upstream; remove once fixed.
const firstUpdated = WaColorPicker.prototype.firstUpdated
WaColorPicker.prototype.firstUpdated = function (changedProperties) {
  firstUpdated.call(this, changedProperties)
  if (this.opacity && this.defaultValue) this.setColor(this.defaultValue)
}

// Keep the singleton toast stack (and its live toasts) from being morphed away
// during Turbo page morphs.
document.addEventListener('turbo:before-morph-element', (event) => {
  if (event.target.localName === 'wa-toast') {
    event.preventDefault()
  }
})
